import {ApiDefinition} from "./ApiDefinition";
import {APIPromise} from "../services/HttpService";
import {ReportRequestType} from "./model/requests/ReportRequestModels";
import {ReportType} from "./model/enums";
import {GeneratedDashboardReportResponse} from "./model/dashboard/GeneratedDashboardReportResponse";

class DashboardReportsApiDefinition extends ApiDefinition {
    constructor() {
        super("/dashboard-reports");
    }

    public getGenerationAndDownloadUrl(params: { dashboardId: number, referenceTime?: string, generateOnly?: boolean, generateNearest?: boolean }): string {
        return this.getFullUrl(`generate-and-download-report`, params);
    }

    async generateReport(params: { dashboardId: number, referenceTime?: string, generateNearest?: boolean }): APIPromise<any> {
        return this.get(`generate-and-download-report`, {params: {...params, generateOnly: true}})
    }

    public getPreviewUrl(dashboardId: number, referenceTime: Date, language: string, jsBuild?: string): string {
        let url =  `${window.contextRoot}/reports-paged.xhtml?dashboardId=${dashboardId}&referenceTime=${referenceTime.toISOString()}&language=${language}`
        if(jsBuild) {
            url = url + `&jsBuild=${jsBuild}`
        }
        return url
    }

    async getGeneratedReports(params: ReportRequestType): APIPromise<Array<GeneratedDashboardReportResponse>> {
        return this.get(`generated`, {params: params});
    }

    public getDownloadUrl(genId: number, reportId: string): string {
        return this.getFullUrl(`download`, {genId: genId, reportId: reportId})
    }

    public getDownloadZipUrl(dashboardId: Array<number>, from: string, to?: string, onlyType?: ReportType): string {
        return this.getFullUrl(`download-zip`, {id: dashboardId, from: from, to: to, onlyType: onlyType})
    }

    async deleteGeneration(genId: number): APIPromise<GeneratedDashboardReportResponse> {
        return this.delete(`${genId}/delete-generation`);
    }

    async deleteReport(genId: number, reportId: string): APIPromise<GeneratedDashboardReportResponse> {
        return this.delete(`${genId}/delete-report`, {params: {reportId: reportId}});
    }

    async deleteReportsRange(dashboardId: number, params: { from: string, to: string }): APIPromise<Array<GeneratedDashboardReportResponse>> {
        return this.delete(`${dashboardId}/delete-reports-range`, {params: params})
    }

    async cleanupReportHistoryRange(dashboardId: number, params: { from: string, to: string }): APIPromise<Array<GeneratedDashboardReportResponse>> {
        return this.delete(`${dashboardId}/cleanup-report-history-range`, {params: params});
    }

    async markForRegeneration(params: { genId: Array<number>, lazyRegen?: boolean }): APIPromise<Array<GeneratedDashboardReportResponse>> {
        return this.post(`mark-for-regeneration`, null, {params: params})
    }

    async markForRegenerationRange(params: { dashboardId: number, from: string, to: string, fillMissingSlots?: boolean }): APIPromise<Array<GeneratedDashboardReportResponse>> {
        return this.post(`mark-for-regeneration-range`, null, {params: params})
    }
}

export const DashboardReportsApi = new DashboardReportsApiDefinition();
